/* TUDD – store reviews section. Loads Judge.me Store Reviews from Judge.me's public widget
   feed (the same feed its All Reviews widget uses) and renders them as TUDD-styled cards. */
(() => {
  if (window.__tuddReviews) return;
  window.__tuddReviews = true;

  const FEED = 'https://cdn.judge.me//reviews/all_reviews_js_based';
  const pageCache = new Map(); // `${shop}|${page}` -> Promise<array>

  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const fmtDate = (str) => {
    const d = new Date((str || '').replace(' UTC', 'Z').replace(' ', 'T'));
    return isNaN(d) ? '' : `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  };
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  function parse(html) {
    const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
    return [...doc.querySelectorAll('.jdgm-rev')].map((r) => ({
      id: r.dataset.reviewId,
      score: parseInt(r.querySelector('.jdgm-rev__rating')?.dataset.score, 10) || 0,
      author: r.querySelector('.jdgm-rev__author')?.textContent.trim() || 'Customer',
      title: r.querySelector('.jdgm-rev__title')?.textContent.trim() || '',
      body: r.querySelector('.jdgm-rev__body')?.textContent.trim() || '',
      date: r.querySelector('.jdgm-rev__timestamp')?.dataset.content || '',
      verified: r.dataset.verifiedBuyer === 'true',
      pics: [...r.querySelectorAll('.jdgm-rev__pics img, .jdgm-rev__pic-img')]
        .map((i) => i.getAttribute('data-src') || i.getAttribute('src'))
        .filter(Boolean)
        .slice(0, 3),
    }));
  }

  function loadPage(shop, page) {
    const key = `${shop}|${page}`;
    if (!pageCache.has(key)) {
      const qs = new URLSearchParams({ url: shop, shop_domain: shop, platform: 'shopify', page, review_type: 'shop-reviews' });
      pageCache.set(
        key,
        fetch(`${FEED}?${qs}`)
          .then((r) => (r.ok ? r.json() : { html: '' }))
          .then((d) => parse(d.html || ''))
          .catch(() => [])
      );
    }
    return pageCache.get(key);
  }

  const card = (r) => `
    <li class="tudd-sr__card">
      <span class="tudd-testi__stars" aria-label="${r.score} out of 5 stars">${[1, 2, 3, 4, 5]
        .map((i) => `<span${i > r.score ? ' class="is-off"' : ''}>★</span>`)
        .join('')}</span>
      ${r.title ? `<p class="tudd-sr__title">${esc(r.title)}</p>` : ''}
      <p class="tudd-sr__body">${esc(r.body)}</p>
      ${r.pics.length ? `<div class="tudd-sr__pics">${r.pics.map((p) => `<img src="${esc(p)}" alt="" loading="lazy" width="64" height="64">`).join('')}</div>` : ''}
      <p class="tudd-sr__by">
        <span class="tudd-testi__name">${esc(r.author)}</span>
        ${r.verified ? '<span class="tudd-testi__verified">✓ Verified buyer</span>' : ''}
        ${fmtDate(r.date) ? `<span class="tudd-sr__date">${fmtDate(r.date)}</span>` : ''}
      </p>
    </li>`;

  async function init(el) {
    if (el.dataset.tuddReady) return;
    el.dataset.tuddReady = 'true';
    const shop = el.dataset.shop;
    const list = el.querySelector('[data-tudd-sr-list]');
    const more = el.querySelector('[data-tudd-sr-more]');
    const initial = parseInt(el.dataset.initial, 10) || 6;
    const step = parseInt(el.dataset.step, 10) || 6;

    let reviews = [];
    let page = 0;
    let exhausted = false;
    let shown = 0;

    const ensure = async (n) => {
      while (reviews.length < n && !exhausted) {
        page += 1;
        const batch = await loadPage(shop, page);
        const fresh = batch.filter((r) => !reviews.some((x) => x.id === r.id));
        if (!fresh.length) exhausted = true;
        reviews = reviews.concat(fresh);
      }
    };

    const show = async (n) => {
      more.disabled = true;
      await ensure(shown + n);
      const next = reviews.slice(shown, shown + n);
      list.insertAdjacentHTML('beforeend', next.map(card).join(''));
      shown += next.length;
      // Peek one page ahead so the button only shows when there really is more
      await ensure(shown + 1);
      more.hidden = shown >= reviews.length;
      more.disabled = false;
      el.hidden = shown === 0;
    };

    more.addEventListener('click', () => show(step));
    await show(initial);
  }

  const boot = () => document.querySelectorAll('[data-tudd-store-reviews]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
